import {
  IEngineRuntimeSection,
  IEngineSection,
} from '../../../schema/sections/IEngineSection';

/**
 * Filtro per rimuovere dal menu le sezioni non visibili
 */
export function filterVisibleSections(input: {
  sectionId: string | null | undefined;
  submissionModuleId: string | null | undefined;
  runtimeSections: Array<IEngineRuntimeSection<IEngineSection>>;
  currentSubmissionModuleId: string | null | undefined;
}) {
  const {
    sectionId,
    submissionModuleId,
    runtimeSections,
    currentSubmissionModuleId,
  } = input;
  return (
    submissionModuleId === currentSubmissionModuleId &&
    runtimeSections.find(s => s.section.id == sectionId)?.visible
  );
}
